import { createContext, useCallback, useState } from 'react';
import { api } from 'services/api';

type ChildrenProps = {
  children: React.ReactNode;
};

type lastBoughtProps = {
  date: string | null;
};

type qualificationProps = {
  days_estimated: number | undefined;
  last_bought: lastBoughtProps;
  average_monthy_leads: string;
  balance_premium: number | undefined;
  balance_light: number | undefined;
  balance_contract: number | undefined;
};

type QualificationContextType = {
  dataQualifierBalance: qualificationProps | null;
  fetchDataQualifierBalance: (
    id: string,
    idTokenParams?: string,
    type_product?: string,
  ) => void;
};

export const QualificationContext = createContext(
  {} as QualificationContextType,
);

export const QualificationProvider = ({ children }: ChildrenProps) => {
  const [dataQualifierBalance, setDataQualifierBalance] =
    useState<qualificationProps | null>(null);

  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');

  const fetchDataQualifierBalance = useCallback(
    async (accessTokenParam, idTokenParams, type_product) => {
      try {
        const { data } = await api.get(
          `qualifier/balance?type_product=${type_product}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessTokenParam || accessToken}`,
              idToken: idTokenParams || idToken,
            },
          },
        );
        setDataQualifierBalance(data.data);
      } catch (error) {
        console.log(error);
      }
    },
    [accessToken, idToken],
  );

  return (
    <QualificationContext.Provider
      value={{ dataQualifierBalance, fetchDataQualifierBalance }}
    >
      {children}
    </QualificationContext.Provider>
  );
};
